import { createApp } from "vue";
import Antd from "ant-design-vue";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getFirestore } from "firebase/firestore";

// Polyfills for Node.js modules
import { Buffer } from 'buffer';
import process from 'process/browser';

window.Buffer = Buffer;
window.process = process;
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import VueClipboard from "vue3-clipboard";
import { decodeAuth } from "./helper/encryptHelper";
import { createStore } from "vuex";
import { createMetaManager, defaultConfig } from "vue-meta";

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import "ant-design-vue/dist/antd.css";
import "element-plus/dist/index.css";
import "flag-icons/css/flag-icons.min.css";
// Import Element Plus components
import ElementPlus from 'element-plus';

import DashboardPlugin from "./dashboard-plugin";
import { meta } from "./util/meta";
const options = { containerClassName: "ct-notification" };

let firebaseApp, auth, functions, db;
try {
  const authConfig = process.env.VUE_APP_AUTH;
  if (!authConfig) {
    throw new Error('VUE_APP_AUTH environment variable is not defined');
  }
  
  const decodedConfig = decodeAuth(authConfig);
  firebaseApp = initializeApp(decodedConfig);
  auth = getAuth(firebaseApp);
  functions = getFunctions(firebaseApp);
  db = getFirestore(firebaseApp);
} catch (error) {
  console.error('Firebase initialization failed:', error);
  // Create fallback objects to prevent further errors
  auth = null;
  functions = null;
  db = null;
}
import VueColor from "@ckpack/vue-color";

import Countdown from "vue3-flip-countdown";

const metaManager = createMetaManager(false, {
  ...defaultConfig,
  meta: { tag: "meta", nameless: true },
});

const store = createStore({
  state: {
    coins: 0,
    luckycoins: 0,
  },
  mutations: {
    setReward(state, payload) {
      state.coins = payload;
    },
    setLuckyReward(state, payload) {
      state.luckycoins = payload;
    },
  },
  actions: {
    setReward(context, payload) {
      context.commit("setReward", payload);
    },
    setLuckyReward(context, payload) {
      context.commit("setLuckyReward", payload);
    },
  },
});

const appInstance = createApp(App);
appInstance.use(router);
appInstance.use(Antd);
appInstance.use(ElementPlus);
appInstance.use(VueColor);
appInstance.use(VueClipboard, {
  autoSetContainer: true,
  appendToBody: true,
});
appInstance.use(Toast, options);
appInstance.use(DashboardPlugin);
appInstance.use(VueAxios, axios);

// Global axios error handler to suppress network errors
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Suppress network errors and other common errors
        if (error.code === 'NETWORK_ERROR' || 
            error.message === 'Network Error' ||
            error.code === 'ECONNABORTED' ||
            error.code === 'ERR_NETWORK') {
            // Return a resolved promise to suppress the error
            return Promise.resolve({ data: null, status: 0 });
        }
        // For other errors, still reject the promise
        return Promise.reject(error);
    }
);

appInstance.use(metaManager);
appInstance.use(Countdown);
appInstance.use(store);
if (auth) {
  auth.useDeviceLanguage();
}
appInstance.mount("#app");
